import ActionMenu from './action-menu.react-svg';
import Amex from './amex.react-svg';
import ApplePay from './apple-pay.react-svg';
import Arrow from './arrow.react-svg';
import Bill from './bill.react-svg';
import Boarding from './boarding.react-svg';
import Bold from './bold.react-svg';
import Breeder from './breeder.react-svg';
import BulletList from './bullet-list.react-svg';
import CalendarPerson from './calendar-person.react-svg';
import Calendar from './calendar.react-svg';
import CardSuccess from './card-success.react-svg';
import CardWallet from './card-wallet.react-svg';
import Cash from './cash.react-svg';
import Cat from './cat.react-svg';
import Catalogue from './catalogue.react-svg';
import Clear from './clear.react-svg';
import Client from './client.react-svg';
import Close from './close.react-svg';
import ClosedDate from './closed-date.react-svg';
import Contactless from './contactless.react-svg';
import Daycare from './daycare.react-svg';
import Delete from './delete.react-svg';
import Desktop from './desktop.react-svg';
import DogPark from './dog-park.react-svg';
import DogWalking from './dog-walking.react-svg';
import Edit from './edit.react-svg';
import Email from './email.react-svg';
import Empty from './empty.react-svg';
import Facebook from './facebook.react-svg';
import Filters from './filters.react-svg';
import GooglePay from './google-pay.react-svg';
import Google from './google.react-svg';
import GriefCounselling from './grief-counselling.react-svg';
import Grooming from './grooming.react-svg';
import HorizontalRule from './horizontal-rule.react-svg';
import Instagram from './instagram.react-svg';
import Italic from './italic.react-svg';
import LineBreak from './line-break.react-svg';
import Linkedin from './linkedin.react-svg';
import Mastercard from './mastercard.react-svg';
import Media from './media.react-svg';
import Megaphone from './megaphone.react-svg';
import Membership from './membership.react-svg';
import NoShow from './no-show.react-svg';
import Note from './note.react-svg';
import Notification from './notification.react-svg';
import OnlineBooking from './online-booking.react-svg';
import OrderedList from './ordered-list.react-svg';
import PataLogo from './pata-logo.react-svg';
import PetCremation from './pet-cremation.react-svg';
import PetHydrotheraphy from './pet-hydrotheraphy.react-svg';
import PetMassage from './pet-massage.react-svg';
import PetService from './pet-service.react-svg';
import PetStore from './pet-store.react-svg';
import PetTransportation from './pet-transportation.react-svg';
import Photography from './photography.react-svg';
import Pin from './pin.react-svg';
import QuoteBlock from './quote-block.react-svg';
import Rocket from './rocket.react-svg';
import Sales from './sales.react-svg';
import Search from './search.react-svg';
import Security from './security.react-svg';
import Settings from './settings.react-svg';
import ShoppingCart from './shopping-cart.react-svg';
import Sitting from './sitting.react-svg';
import Smartphone from './smartphone.react-svg';
import Sort from './sort.react-svg';
import Strikethrough from './strikethrough.react-svg';
import Tap from './tap.react-svg';
import Tax from './tax.react-svg';
import Team from './team.react-svg';
import Terminal from './terminal.react-svg';
import TextMessage from './text-message.react-svg';
import Thunder from './thunder.react-svg';
import Tick from './tick.react-svg';
import Training from './training.react-svg';
import Underline from './underline.react-svg';
import Undo from './undo.react-svg';
import User from './user.react-svg';
import Vet from './vet.react-svg';
import Visa from './visa.react-svg';
import Workplace from './workplace.react-svg';

// import { ReactComponent as Other } from './other.svg';

export const Icons: { [key: string]: React.FC } = {
  Client,
  User,
  Calendar,
  Sales,
  Team,
  Settings,
  Catalogue,
  Workplace,
  ActionMenu,
  Arrow,
  Cat,
  Close,
  Delete,
  Edit,
  Notification,
  Search,
  Empty,
  PataLogo,
  Filters,
  Bold,
  Strikethrough,
  Italic,
  Underline,
  Clear,
  BulletList,
  OrderedList,
  QuoteBlock,
  Undo,
  ClosedDate,
  Membership,
  Note,
  Sort,
  Grooming,
  DogWalking,
  Boarding,
  Daycare,
  Breeder,
  PetStore,
  Sitting,
  Training,
  LineBreak,
  HorizontalRule,
  Tax,
  Media,
  Terminal,
  // Other,
  Cash,
  TextMessage,
  Email,
  Google,
  Pin,
  Tick,
  PetService,
  Vet,
  NoShow,
  PetTransportation,
  ShoppingCart,
  Smartphone,
  PetCremation,
  PetHydrotheraphy,
  Desktop,
  Megaphone,
  CalendarPerson,
  Facebook,
  Linkedin,
  Instagram,
  OnlineBooking,
  Mastercard,
  Amex,
  Visa,
  GooglePay,
  ApplePay,
  Contactless,
  Bill,
  Thunder,
  Security,
  DogPark,
  GriefCounselling,
  PetMassage,
  Photography,
  Rocket,
  Tap,
  CardWallet,
  CardSuccess,
};
